/* NAILZ: Prueba pedicure
   Al elegir un color cambia la escena (pie + lámina) y el nombre del color.
   Las muestras funcionan como radio: flechas del teclado para moverse. */
if (!customElements.get('nailz-pedicure-prueba')) {
  customElements.define(
    'nailz-pedicure-prueba',
    class NailzPedicurePrueba extends HTMLElement {
      connectedCallback() {
        this.swatches = [...this.querySelectorAll('.nzp__swatch')];
        this.swatches.forEach((swatch, index) => {
          swatch.addEventListener('click', () => this.select(swatch));
          swatch.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        // En el editor de temas, al elegir un bloque se muestra ese diseño.
        this.onBlockSelect = (event) => {
          const swatch = event.target.closest && event.target.closest('.nzp__swatch');
          if (swatch && this.contains(swatch)) this.select(swatch);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(swatch, focus = false) {
        const look = swatch.dataset.look;
        this.swatches.forEach((item) => {
          const active = item === swatch;
          item.setAttribute('aria-checked', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        this.querySelectorAll('.nzp__look').forEach((item) => {
          item.classList.toggle('is-active', item.dataset.look === look);
        });
        this.querySelectorAll('.nzp__picker-name').forEach((item) => {
          item.hidden = item.dataset.look !== look;
        });
        if (focus) swatch.focus();
      }

      onKeydown(event, index) {
        const steps = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(event.key in steps)) return;
        event.preventDefault();
        const total = this.swatches.length;
        this.select(this.swatches[(index + steps[event.key] + total) % total], true);
      }
    }
  );
}
